
import { format } from "date-fns";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

interface SearchResultsProps {
  results: any[];
  selectedProfile: any;
  onSelect: (profile: any) => void;
  onConfirm: () => void;
}

export function SearchResults({ results, selectedProfile, onSelect, onConfirm }: SearchResultsProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium">Search Results</h3>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {results.map((profile) => (
          <div 
            key={profile.id}
            className={`p-3 border rounded-lg flex items-center justify-between cursor-pointer hover:bg-accent ${
              selectedProfile?.id === profile.id ? 'bg-accent/50 border-primary' : ''
            }`}
            onClick={() => onSelect(profile)}
          >
            <div className="space-y-1">
              <p className="font-medium flex items-center gap-2">
                <span>{profile.phone_number || 'No phone number'}</span>
                {profile.admin_user_id && (
                  <span className="inline-flex items-center px-2 py-0.5 text-xs rounded-full bg-amber-100 text-amber-800">
                    Linked
                  </span>
                )}
              </p>
              <p className="text-xs text-muted-foreground">
                Created: {format(new Date(profile.created_at), 'MMM d, yyyy')}
              </p>
            </div>
            
            {selectedProfile?.id === profile.id && (
              <Check className="h-5 w-5 text-primary" />
            )}
          </div>
        ))}
      </div>
      
      <Separator />
      
      <div className="flex justify-end">
        <Button
          onClick={onConfirm}
          disabled={!selectedProfile}
        >
          Link Selected Profile
        </Button>
      </div>
    </div>
  );
}
